export {
  TocNav,
  TocNavItem,
  type TocNavProps,
  type TocNavItemProps,
  type TocNavEntry,
} from './TocNav';
export { tocNavVariants, type TocNavVariantProps } from './toc-nav.variants';
